// icon:arrows_diagonal | Linea Iconset https://linea.io/ | Benjamin Sigidi
import * as React from "react";

function LineSegmentTool(props) {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="currentColor"
      height="1.5em"
      width="1.5em"
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinejoin="bevel"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M63 12V1H52M1 52v11h11M1 63L63 1"
      />
    </svg>
  );
}

export default LineSegmentTool;
